import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const ExcitingPage = ({ catData }) => {
  return (
    <>
      <section className="cat-tabs">
        <div className="col-xl-9 mx-auto text-center">
          <div className="landint-title">
            {catData.length > 0 ? <h3>Exciting Offers for Corporate Employees</h3> : ""}
          </div>
        </div>
        <div className="container ">
          <Tabs>
            <TabList>
              {catData &&
                catData.map((category, index) => (
                  <>
                    <Tab>{category.title}</Tab>
                  </>
                ))}
            </TabList>
            {catData &&
              catData.map((category, index) => (
                <>
                  <TabPanel>
                    <div className="tab-content">
                      <div className="left-image">
                        <Link to={category.catImgLeftUrl ? category.catImgLeftUrl : "/home"}>
                          <img src={category.catImgLeft} alt={category.title + "Left Image"} />
                        </Link>
                      </div>
                      <div className="right-image">
                        <Link to={category.catImgRightUrl ? category.catImgRightUrl : "/home"}>
                          <img src={category.catImgRight} alt={category.title + "Right Image"} />
                        </Link>
                      </div>
                    </div>
                    {category.content && 
                    <div className="textcontent">
                      <p style={{textAlign: 'center'}}>{category.content}</p>
                    </div>}
                  </TabPanel>
                </>
              ))}
          </Tabs>
        </div>
      </section>
    </>
  );
};

export default ExcitingPage;
